import { fetchAuthSession } from "aws-amplify/auth";
import { useOutletContext } from "react-router-dom";

export async function getToken() {
  // const [
  //   auth,
  //   setAuth,
  //   user,
  //   setUser,
  //   darkmode,
  //   setDarkmode,
  //   nav,
  //   setNav,
  //   setError,
  //   setLoading,
  // ]: any = useOutletContext();
  try {
    const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};
    console.log("getToken: accessToken = ", accessToken);
    // if access token undefined - clear profile information
    if (accessToken === undefined) {
      // setUser({});
    }
    return String(accessToken);
  } catch (err) {
    console.log("getToken: error =", err);
  }
}
